import { useEffect, useRef, useState } from 'react';
import GradientBorder from '../../ui/GradientBorder';
import { sharingSocials } from './sharingSocials';

// const SHARE_URL = 'https://www.appstore.com';
// const SHARE_TEXT = 'Check out my achievement for leading climate action on Impact Foundry!';
// const SHARE_IMAGE = 'https://yourdomain.com/path-to-share-image.png'; // Replace with actual image link

const handleShare = (label, shareId, shareData, onShareClick) => {
    // Use custom onShareClick if provided, otherwise use default behavior
    if (onShareClick) {
        onShareClick(label, shareId);
        return;
    }

    // Default behavior for backward compatibility
    const SHARE_URL = encodeURIComponent(`https://app.impactfoundry.xyz/greenpill/share/${shareId}`);
    const SHARE_TEXT = encodeURIComponent('Check out my achievement for leading climate action on Impact Foundry!');
    let shareLink = '';

    switch (label.toLowerCase()) {
        case 'whatsapp':
            shareLink = `https://wa.me/?text=${SHARE_TEXT}%20${SHARE_URL}`;
            break;
        case 'telegram':
            shareLink = `https://t.me/share/url?url=${SHARE_URL}&text=${SHARE_TEXT}`;
            break;
        case 'facebook':
            shareLink = `https://www.facebook.com/sharer/sharer.php?u=${SHARE_URL}`;
            break;
        case 'twitter':
            shareLink = `https://twitter.com/intent/tweet?url=${SHARE_URL}&text=${SHARE_TEXT}`;
            break;
        case 'reddit':
            shareLink = `https://www.reddit.com/submit?url=${SHARE_URL}&title=${SHARE_TEXT}`;
            break;
        case 'messages':
            shareLink = `sms:&body=${SHARE_TEXT}%20${SHARE_URL}`;
            break;
        case 'copy link':
            navigator.clipboard.writeText(decodeURIComponent(SHARE_URL));
            alert('Link copied to clipboard!');
            return;
        case 'discord':
            alert('Please paste the link manually in Discord.');
            return;
        case 'snapchat':
        case 'instagram':
        case 'stories':
            alert(`${label} does not support direct web sharing. Please share manually.`);
            return;
        default:
            return;
    }

    window.open(shareLink, '_blank');
};

const ShareAchievment = ({ onShareClick, shareData }) => {
    const [open, setOpen] = useState(false);
    const myRef = useRef();
    useEffect(() => {
        function handleClick(e) {
            if (myRef.current && !myRef.current.contains(e.target)) {
                setOpen(false);
            }
        }
        document.addEventListener('click', handleClick, true);
        return () => document.removeEventListener('click', handleClick, true);
    }, []);

    return (
        <div className="relative" ref={myRef}>
            <GradientBorder
                radiusBorder={'.25rem'}
                color2={'rgba(80, 108, 102, 0)'}
                color1={'rgba(105, 159, 132, 1)'}
                bg="bg-[#1E3D36]"
                shadow="shadow-button-shadow"
                width={'w-full'}
            >
                <button
                    onClick={() => setOpen((prev) => !prev)}
                    type="button"
                    className={` px-4 py-2 flex items-center gap-2 w-full  justify-center`}
                >
                    <span className="text-sm text-white font-medium">Share Achievment</span>
                    <span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none">
                            <path
                                d="M11.9679 10.9733C11.3983 10.9733 10.8887 11.2017 10.499 11.5595L5.15564 8.40004C5.19312 8.22493 5.22309 8.04983 5.22309 7.86711C5.22309 7.6844 5.19312 7.50929 5.15564 7.33419L10.4391 4.20516C10.8438 4.58582 11.3758 4.82183 11.9679 4.82183C12.5642 4.82183 13.136 4.5812 13.5577 4.15287C13.9793 3.72455 14.2162 3.14361 14.2162 2.53787C14.2162 1.93212 13.9793 1.35119 13.5577 0.922863C13.136 0.494537 12.5642 0.253906 11.9679 0.253906C11.3716 0.253906 10.7998 0.494537 10.3781 0.922863C9.95649 1.35119 9.71962 1.93212 9.71962 2.53787C9.71962 2.72059 9.7496 2.89569 9.78707 3.07079L4.50365 6.19982C4.09896 5.81916 3.56687 5.58315 2.97483 5.58315C2.37855 5.58315 1.8067 5.82378 1.38506 6.25211C0.963433 6.68043 0.726563 7.26137 0.726562 7.86711C0.726563 8.47286 0.963433 9.05379 1.38506 9.48212C1.8067 9.91045 2.37855 10.1511 2.97483 10.1511C3.56687 10.1511 4.09896 9.91507 4.50365 9.53441L9.83953 12.6939C9.80206 12.8538 9.77958 13.0213 9.77958 13.1964C9.77958 14.4221 10.7613 15.4118 11.9679 15.4118C13.1745 15.4118 14.1562 14.4221 14.1562 13.1964C14.1562 12.6068 13.9256 12.0413 13.5153 11.6244C13.1049 11.2075 12.5483 10.9733 11.9679 10.9733Z"
                                fill="#E8E8E8"
                            />
                        </svg>
                    </span>
                </button>
            </GradientBorder>

            <div
                className={`z-[2000] w-full ${
                    open ? 'absolute' : 'hidden'
                } bg-[#3C504B]  overflow-auto main rounded-lg rounded-t-none shadow px-4 py-3`}
            >
                <div className="grid grid-cols-7 gap-2">
                    {sharingSocials?.map((social) => {
                        return (
                            <div
                                onClick={() => handleShare(social.label, '1234', shareData, onShareClick)}
                                className="flex flex-col items-center cursor-pointer hover:opacity-80 transition-opacity"
                                key={social?.label}
                            >
                                <img className="w-11 h-11   " src={social?.image} alt={social?.label} />
                                <span className="text-white text-[.65rem]">{social?.label}</span>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default ShareAchievment;
